import { LOADING_STATES } from "../../../../features/loading";

import { createCampaignBriefProductsState } from "../../features/campaign-brief-products/types/campaign-brief-products.functions";

import { CampaignBriefState } from "./campaign-brief-state.interface";

export function createCampaignBriefState(): CampaignBriefState {
  return {
    currentTab: 0,
    attachedFiles: [],
    data: {
      additionalCreativeRequirementsDetails: "",
      additionalDetails: "",
      announcementDate: "",
      areVendorAssetsProvided: null,
      audience: "",
      awareness: null,
      background: "",
      brandFrameworkSupport: "",
      briefOwner: {
        id: 0,
        firstName: "",
        lastName: "",
      },
      categoryLift: null,
      context: "",
      content: "",
      createdAt: "",
      customerMessage: "",
      customerTakeaway: "",
      dependentUserDetails: {
        campaignBriefOwner: 0,
        campaignBriefReviewers: [],
        executionBriefMerchOwners: [],
        executionBriefOwners: [],
        executionBriefReviewers: [],
        workOrderOwners: [],
        workOrderReviewers: [],
        workOrderContentCreators: [],
      },
      endAt: "",
      executionPlansDueAt: null,
      hasVendorCommitment: null,
      overviewAttachments: [
        {
          id: 0,
          ownerDetails: {
            id: 0,
            firstName: "",
            lastName: "",
            email: "",
          },
          isAsset: false,
          mimetype: "",
          attachment: "",
          description: "",
          campaignBrief: 0,
          owner: 1,
          createdAt: "",
          updatedAt: "",
        },
      ],
      id: 0,
      insight: "",
      isExclusive: null,
      isInstore: null,
      isMap: null,
      isOnline: null,
      isRegional: null,
      isUnderNda: null,
      keyFeatures: "",
      launchDate: "",
      legalRequirementsDetails: "",
      mandatoryCreativeRequirementsDetails: "",
      marketingChannels: [],
      marketingSupportLevel: "",
      messagingPrimary: "",
      messagingSecondary: "",
      name: "",
      numberOfStores: "",
      objectives: "",
      offerDetails: "",
      opportunity: "",
      otherMarketingChannels: "",
      overview: "",
      polymorphicCtype: undefined,
      preOrderDate: "",
      previousResults: "",
      productPlacement: "",
      regions: [],
      resourcetype: "",
      revenue: null,
      reviewers: [],
      salesForecast: null,
      startAt: "",
      status: "draft",
      targetSalesForecast: null,
      targetTimeframe: "",
      targetUnitForecast: null,
      tonality: "",
      trafficInstore: null,
      trafficOnline: null,
      underNdaUserDetails: [],
      underNdaUsers: [],
      updatedAt: "",
      vendorAssetsLocation: "",
      warehouseEta: "",
    },
    errors: null,
    formErrors: null,
    loading: LOADING_STATES.default,
    showAddProductModal: false,
    showNewBriefModal: false,
    productsState: createCampaignBriefProductsState(),
  };
}
